module.exports = __webpack_public_path__ + "static/media/trustpilot.f37cd1ef.svg";